import styled from 'styled-components';
import exclamationIconSVG from 'icons/exclamation-mark.svg';
import { mediaBreakpointDown } from 'styles/grid';
import { ReactSVG } from 'react-svg';

export const ErrorContainer = styled.div`
  ${mediaBreakpointDown.sm} {
    margin-bottom: 24px;
  }
`;

// ptp config has 6 digits hex => need to concat an extra 2 digits for alpha % (80)
// reference: https://css-tricks.com/8-digit-hex-codes/
export const InfoLabel = styled.div`
  background-color: ${({ theme }) =>
    theme.configs.CTAButton.bgColor.concat('80')};
  color: ${({ theme }) => theme.configs.CTAButton.fontColor};
  font-weight: 600;
  padding: 16px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
`;

export const ExclamationMarkIcon = styled(ReactSVG).attrs((props) => {
  return {
    src: exclamationIconSVG,
    'aria-hidden': true,
    ...props,
  };
})`
  flex-shrink: 0;
  margin-right: 10px;
  path {
    fill: ${({ theme }) => theme.configs.CTAButton.fontColor};
  }
`;

export const QRImage = styled.img`
  width: 200px;
  height: auto;
  max-height: 200px;
  object-fit: contain;
  margin: 0 auto 8px auto;
  display: block;

  ${mediaBreakpointDown.sm} {
    width: 220px;
    max-height: 220px;
  }
`;
